import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import ApplicationModule from "@/store/modules/application.module";
import TravelSearchModule from "./modules/travelSearch.module";
import TravelSearchResponseModule from "./modules/travelSearchResponse.module";
import TravelSearchFilterModule from './modules/travelSearchFilter.module';
import TravelSearchBookingModule from './modules/travelSearchBooking.module';

export default createStore({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    ApplicationModule,
    TravelSearchModule,
    TravelSearchResponseModule,
    TravelSearchFilterModule,
    TravelSearchBookingModule
  },
  plugins: [createPersistedState({ storage: window.sessionStorage })],
})